import { openModal, selectAuthSettings, selectFiatMeta, useAppDispatch, useAppSelector } from 'BreetRedux';
import { useCallback } from 'react';

export const useWithdrawRequestApi = () => {
	const dispatch = useAppDispatch();

	const authSettings = useAppSelector(selectAuthSettings);

	const fiatMeta = useAppSelector(selectFiatMeta);

	const withdrawalEnabled = authSettings?.withdrawalMeta?.vip?.withdrawal?.enabled[fiatMeta.countryLower] ?? false;

	const withdrawalEnabledUsd = authSettings?.usdWithdrawalMeta?.enabled ?? false;

	const withdrawalNotAvailable = useCallback(() => {
		dispatch(
			openModal({
				id: 'alert',
				metadata: {
					title: 'Withdrawal Unavailable',
					description: 'Oops! Withdrawals will be available soon. Please try again later.',
				},
			})
		);
	}, [dispatch]);

	const withdrawFunds = useCallback(() => {
		if (!withdrawalEnabled) {
			withdrawalNotAvailable();
		} else {
			dispatch(openModal({ id: 'requestPayment', variant: 'right-sheet' }));
		}
	}, [dispatch, withdrawalEnabled, withdrawalNotAvailable]);

	const withdrawFundsUsd = useCallback(() => {
		if (!withdrawalEnabledUsd) {
			withdrawalNotAvailable();
		} else {
			dispatch(openModal({ id: 'requestPaymentUsd', variant: 'right-sheet' }));
		}
	}, [dispatch, withdrawalEnabledUsd, withdrawalNotAvailable]);

	return {
		withdrawFunds,
		withdrawFundsUsd,
		fiatMeta,
	};
};
